<template>
  <div>
      <h2>Edit lexicon group</h2><br >
      New description will be:
      <input type="text" v-model="desc" />&nbsp;
      <button v-on:click="saveEditLexiconGroup()" class="btn-success">Save</button>&nbsp;
      <button v-on:click="$router.go(-1)" class="btn-danger">Cancel</button>
      <div v-if="error">
        <font color="red">Please type a proper description for the lexicon entry</font>
      </div>
  </div>
</template>

<script>
import apiClient from '@/services/api_client_saas.js'
import router from '../router'

export default {
  name: 'LexiconEdit',
  data: function () {
    return {
      desc: '',
      error: false
    }
  },
  mounted: function () {
    if (!this.$route.params.id) {
      router.push({ name: 'Lexicons' })
      return
    }

    apiClient.get('/api/lexicons/item/' + this.$route.params.id).then((response) => {
      console.log(response)
      this.desc = response.data.group[0].lexicon_description
    }).catch((error) => {
      if (error.response) {
        console.log(error.response.data)
      }
    })
  },
  methods: {
    saveEditLexiconGroup: function (id) {
      this.error = false
      if (!this.desc.trim()) {
        this.error = true
        return
      }

      apiClient.put('/api/lexicons/edit', {
        id: this.$route.params.id,
        desc: this.desc
      }).then((response) => {
        if (response.status === 201) {
          router.push({ name: 'Lexicons' })
        }
      }).catch((error) => {
        if (error.response) {
          console.log(error.response.data)
        }
      })
    }
  },
  created: function () {
  }
}
</script>
